<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Tatil"
    }
</script>

<style scoped>

</style>